import { JustpaySbpEndpointService } from "@/views/loyalty/shared/endpoint_services/justpay-sbp-endpoint-service"

export class JustpaySbpService {
    constructor () {
        this.justpaySbpEndpointService = new JustpaySbpEndpointService()
    }

    async getByOrderId (orderId) {
        return this.justpaySbpEndpointService.getByOrderId(orderId)
    }
}
